import { render, staticRenderFns } from "./ModalTicket.vue?vue&type=template&id=6268167e&"
import script from "./ModalTicket.vue?vue&type=script&lang=js&"
export * from "./ModalTicket.vue?vue&type=script&lang=js&"
import style0 from "./ModalTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports